module.exports = (parcelRequire.load("7qf8x")).then(() => parcelRequire('24jNb'));